import React, { useRef, useEffect } from "react"
import { registerForUpdates, unregisterForUpdates } from "../db/db"

export const useLiveValue = (getter, updater) => {
    const result = useRef(getter())
    const [, triggerRender] = React.useState(0)
    useEffect(() => {
        const id = registerForUpdates(updateId => {
            result.current = updater ? updater(updateId) : getter(updateId)
            triggerRender(n => (n + 1) % 100)
        })
        return () => {
            unregisterForUpdates(id)
        }
    }, [getter, updater])
    return result.current
}
